import { Button, Modal } from "flowbite-react";
import { getLinkTypeLabel } from "../../utils/storeLinks";

function LinkChoiceModal({
  open,
  onClose,
  title,
  subtitle = null,
  links = [],
  onSelect,
}) {
  return (
    <Modal show={open} size="md" onClose={onClose}>
      <Modal.Header>{title || "Escolha uma opcao"}</Modal.Header>
      <Modal.Body>
        <div className="space-y-3">
          {subtitle ? <p className="text-sm text-gray-600">{subtitle}</p> : null}
          {links.map((link, index) => {
            const label =
              link?.label || `${getLinkTypeLabel(link?.tipo)} ${index + 1}`;

            return (
              <Button
                key={link?.id || `${link?.tipo}-${index}`}
                color="light"
                className="w-full justify-start"
                onClick={() => onSelect?.(link)}
              >
                <div className="flex w-full flex-col items-start">
                  <span className="font-semibold text-gray-900">{label}</span>
                  {link?.valor ? (
                    <span className="text-xs text-gray-600">{link.valor}</span>
                  ) : null}
                </div>
              </Button>
            );
          })}
        </div>
      </Modal.Body>
    </Modal>
  );
}

export default LinkChoiceModal;
